import type { UsPlayerCatalogue } from './usPlayerCatalogue';

/** #1110: the US props header count. Only a successful read is a count; a
 * failed read keeps the last confirmed inventory and says so; before any read
 * has listed a market the count is unknown ("—"), never a confirmed 0. */
export function usCatalogueCount(catalogue: UsPlayerCatalogue, count: number): string {
  if (catalogue.status === 'ready') return `Full game · ${marketCount(count)}`;
  return catalogue.markets.length > 0 ? `Last confirmed full game · ${marketCount(count)}` : 'Full game · — markets';
}

function marketCount(count: number): string {
  return `${count} ${count === 1 ? 'market' : 'markets'}`;
}

/** Quick reference on a US props YES/NO button. */
export function usOpenTitle(outcome: 'yes' | 'no'): string {
  return `Opens the US ticket for this contract's ${outcome.toUpperCase()}; the price shown is the best bid.`;
}
